<div class="page-list-item col-12">
    <div class="image" *ngIf="imgSrc!= null && imgSrc.length>0" style="{{'background-color:'+bgColor+';'}}">
        <img  [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +imgSrc ">
    </div>
    <div class="logo" *ngIf="logoSrc!= null && logoSrc.length>0">

        <img style="width: 60px;height: 60px;" [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +logoSrc ">
    </div>
    <h2 *ngIf="pageType=='NEWS' || pageType=='BLOG'">{{title}}</h2>
    <p class="text">
        {{text}}
    </p>
    <div class="lnk" >
        <button class="button link-btn" (click)="goToPage(uid)" >
            <span i18n="@@See more">See more</span>
            <i *ngIf="getDirection() == 'rtl'" class="pi pi-angle-left"></i>
            <i *ngIf="getDirection() == 'ltr'" class="pi pi-angle-right"></i>
        </button>
    </div>
</div>
